// Review editörü senkron kuralları (Finar 14.8 — imleç sona atlıyor, yoklama yazılanı siliyordu).
// Saf yardımcılar: Review.tsx yerel metni ne zaman sıfırlar, SectionEditor dış içeriği ne zaman
// editöre basar. Kök neden: her `loadSections` (3 sn yoklama, SSE) yerel metni sunucu metniyle
// eziyordu; editör de kendi yaydığı markdown'ı HTML↔HTML karşılaştırmasıyla "farklı" sanıp
// `setContent` çağırıyor, seçimi sıfırlıyordu.

/** Yerel metin yalnız aktif bölüm DEĞİŞİNCE sunucu metnine sıfırlanır; aynı bölümün yeniden
 *  yüklenmesi (yoklama/SSE) yerel metne dokunmaz — kirli olsun olmasın. */
export function shouldResetLocalContent(
  prev: { sectionId: string | null },
  next: { sectionId: string | null },
): boolean {
  return prev.sectionId !== next.sectionId;
}

/** Editör yalnız kendi yaydığından FARKLI içerik gelince güncellenir; kendi yaydığı markdown
 *  geri döndüğünde `setContent` çağrılmaz (çağrılırsa imleç sona atlar). */
export function shouldSyncEditor(lastEmitted: string | null, incoming: string): boolean {
  return incoming !== lastEmitted;
}

/** Aynı bölümde sunucu metni değiştiyse (KK adayı kabulü, yeniden üretim, kayıt) ve yerel metin
 *  önceki sunucu metniyle aynıysa (kullanıcı bir şey yazmamış) yeni sunucu metni alınır.
 *  Kullanıcı yazmışsa yazdığı korunur. */
export function shouldAdoptServerContent(
  prevServer: string,
  nextServer: string,
  local: string,
): boolean {
  return prevServer !== nextServer && local === prevServer;
}

/** Final review I2: aynı bölümde sunucu metni değişti (yeniden üretim / KK kabulü) ama kullanıcı
 *  yazmış (yerel ≠ önceki sunucu) ve yazdığı yeni sunucu metniyle de aynı değil → sessiz ayrışma.
 *  Review bu durumda "Sunucu metnini al / Benimkini koru" bandını gösterir (Kaydet sunucuyu ezerdi). */
export function serverChangedWhileDirty(
  prevServer: string,
  nextServer: string,
  local: string,
): boolean {
  return prevServer !== nextServer && local !== prevServer && local !== nextServer;
}
